import { IDirectScheduleLocation } from '@sondermind/utilities/models-direct-scheduling';

export class DirectScheduleLocation implements IDirectScheduleLocation {
  addressLine1: string;
  addressLine2: string;
  city: string;
  name: string;
  state: string;
  zip: string;
  googleMapUrl?: string;
  id?: number;

  constructor(json: IDirectScheduleLocationAPIResponse) {
    if (!json) { return }

    this.addressLine1 = json.address_line1;
    this.addressLine2 = json.address_line2;
    this.city = json.city;
    this.name = json.name;
    this.state = json.state;
    this.zip = json.zip;
    this.googleMapUrl = json.google_map_url;
    this.id = json.id;
  }
}

export interface IDirectScheduleLocationAPIResponse {
  address_line1: string;
  address_line2: string;
  city: string;
  name: string;
  state: string;
  zip: string;
  google_map_url?: string;
  id?: number;
}
